module.exports = __webpack_public_path__ + "img/payment-type.bcad9312.jpeg";